var getPublicHolidayName = function getPublicHolidayName(_ref) {
  var dToday = _ref.dToday,
      widgetData = _ref.widgetData;
  var strToday = dToday.getDate() + "-" + (dToday.getMonth() + 1) + "-" + dToday.getFullYear();
  var arrPublicHolidays = widgetData.jsonSettings.settings.publicholidays.dates;
  var publicHoliday = arrPublicHolidays.find(function (holiday) {
    return holiday.date === strToday;
  });
  return publicHoliday ? publicHoliday.name : '';
};

export default getPublicHolidayName;